import { createFileRoute } from "@tanstack/react-router";
import GrantsDirectory from "@/pages/GrantsDirectory";
import { comunidadFromSlug, territoryHead } from "@/lib/subvencionesSeo";

export const Route = createFileRoute("/en/grants/region/$comunidad")({
  head: ({ params }) => {
    const name = comunidadFromSlug(params.comunidad) ?? params.comunidad;
    const h = territoryHead("en", name);
    return {
      meta: [
        { title: h.title },
        { name: "description", content: h.description },
        { name: "keywords", content: h.keywords },
        { property: "og:title", content: h.title },
        { property: "og:description", content: h.description },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
    };
  },
  component: () => <GrantsDirectory kind="territory" />,
});
